import React from 'react'
import { Helmet } from 'react-helmet'
import TaskList from './components/TaskList'

function Task() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`Add Task | ${process.env.REACT_APP_PROJECT_NAME}`}</title>
      </Helmet>

      <TaskList />
    </>
  )
}

export default Task